export function BankIcon() {
    return (
        <svg
            width={40}
            height={40}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.294 36.156h33.412M.617 38.852h38.766M5.971 33.46H34.03'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.971 16.765V33.46M10.037 16.765V33.46M17.967 16.765V33.46M22.033 16.765V33.46M29.963 16.765V33.46M34.029 16.765V33.46'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinejoin='round'
            />
            <path
                d='M2.193 10.763L20 .615l17.51 10.148c.606.355.356 1.282-.347 1.282H2.533c-.708 0-.958-.932-.34-1.282zM4.343 14.741h7.318M16.338 14.741h7.318M28.334 14.741h7.318'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function MoneyIcon() {
    return (
        <svg
            width={49}
            height={46}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M33.693 28.376s4.231-3.205 7.106-5.373c2.622-1.974 4.74-1.511 6.494-.113a.927.927 0 01.048 1.393L34.15 36.74a1.761 1.761 0 01-1.207.48h-17.3'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.963 31.001c3.545-4.459 6.355-6.158 9.857-6.158 2.928 0 4.488.344 6.987 2.027h5.363c.783 0 3.212.318 3.641 3.545a.924.924 0 01-.917 1.038H22.587'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2 32.722l4.231-4.244 12.007 12.048-4.231 4.244'
                fill='#fff'
            />
            <path
                d='M2 32.722l4.231-4.244 12.007 12.048-4.231 4.244'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.043 34.067a1.113 1.113 0 000 1.565c.43.43 1.132.43 1.56 0a1.113 1.113 0 000-1.565 1.105 1.105 0 00-1.56 0z'
                fill='#696F79'
            />
            <path
                d='M29.044 21.648c4.68 0 8.473-3.805 8.473-8.498s-3.794-8.498-8.473-8.498c-4.68 0-8.473 3.805-8.473 8.498s3.793 8.498 8.473 8.498z'
                fill='#fff'
                stroke='#fff'
                strokeWidth={7.447}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M29.044 21.648c4.68 0 8.473-3.805 8.473-8.498s-3.794-8.498-8.473-8.498c-4.68 0-8.473 3.805-8.473 8.498s3.793 8.498 8.473 8.498z'
                fill='#fff'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M31.532 10.977c-.815-2.178-4.494-1.92-4.52.35-.011 1.016 1.174 1.484 2.166 1.64 3.62.57 2.617 3.985 0 3.856-1.984-.096-2.558-1.447-2.623-1.77'
                fill='#fff'
            />
            <path
                d='M31.532 10.977c-.815-2.178-4.494-1.92-4.52.35-.011 1.016 1.174 1.484 2.166 1.64 3.62.57 2.617 3.985 0 3.856-1.984-.096-2.558-1.447-2.623-1.77M29.22 7.643V9.47M29.22 16.823v1.83'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function LiquidityAssetsIcon() {
    return (
        <svg
            width={41}
            height={43}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M31.147 23.246a.963.963 0 00.962-.964.963.963 0 00-.962-.965.963.963 0 00-.961.965c0 .532.43.964.961.964z'
                fill='#696F79'
            />
            <path
                d='M39.344 24.516l-3.32-.974c-.727-2.244-2.311-4.227-4.49-5.757.241-1.048.78-2.194 1.507-3.168.377-.507.132-1.245-.486-1.363-2.747-.531-5.308.3-6.858 1.948a20.372 20.372 0 00-4.812-.57c-8.614 0-15.595 5.22-15.595 11.665 0 3.527 2.1 6.68 5.406 8.816l2.227 5.973h3.12l1.712-3.36c1.01.152 2.055.236 3.125.236 1.07 0 2.114-.084 3.125-.236l1.712 3.36h3.12l2.227-5.973c1.687-1.092 3.05-2.445 3.993-3.98l4.282-1.127v-5.49h.005zM15.807 37.322a20.4 20.4 0 001.948.397'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.942 17.121s-.108-.005-.118 0c-.01.005-.093.044-.108.059a.659.659 0 00-.078.113.504.504 0 00-.025.158c0 .039.02.127.04.177.019.049.068.128.112.172a.895.895 0 00.182.143.925.925 0 00.24.083c.079.015.191.02.285.005.093-.01.206-.044.299-.083.093-.045.2-.109.284-.183a1.337 1.337 0 00.403-.644 1.626 1.626 0 00-.005-.876 1.772 1.772 0 00-.197-.443 2.088 2.088 0 00-.328-.398 2.063 2.063 0 00-.991-.497 2.316 2.316 0 00-1.221.098 2.413 2.413 0 00-.59.31c-.18.128-.357.29-.505.478a2.827 2.827 0 00-.598 2.135c.034.265.098.536.201.792a3.203 3.203 0 001.035 1.353c.236.177.5.334.785.448.285.113.594.196.903.236a3.72 3.72 0 001.923-.29 3.84 3.84 0 00.878-.532 4.02 4.02 0 00.372-.34M28.287 36.554c1-.408 1.933-.89 2.787-1.441M27.91 15.904c-.702-.28-1.443-.52-2.208-.707'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M22.549 15.768a6.99 6.99 0 000-9.866 6.942 6.942 0 00-9.838 0 6.99 6.99 0 000 9.866 6.942 6.942 0 009.838 0z'
                fill='#fff'
                stroke='#fff'
                strokeWidth={7.447}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M22.549 15.768a6.99 6.99 0 000-9.866 6.942 6.942 0 00-9.838 0 6.99 6.99 0 000 9.866 6.942 6.942 0 009.838 0z'
                fill='#fff'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M19.673 9.048c-.667-1.791-3.689-1.58-3.713.285-.01.832.966 1.22 1.78 1.348 2.968.472 2.149 3.272 0 3.164-1.628-.08-2.1-1.186-2.153-1.452'
                fill='#fff'
            />
            <path
                d='M19.673 9.048c-.667-1.791-3.689-1.58-3.713.285-.01.832.966 1.22 1.78 1.348 2.968.472 2.149 3.272 0 3.164-1.628-.08-2.1-1.186-2.153-1.452M17.775 6.312v1.506M17.774 13.85v1.5'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M23.872 17.766a16.956 16.956 0 00-2.418-.172c-3.1 0-5.975.836-8.139 2.189'
                stroke='#fff'
                strokeWidth={7.447}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M23.872 17.766a16.956 16.956 0 00-2.418-.172c-3.1 0-5.975.836-8.139 2.189'
                stroke='#696F79'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
